import { Route } from "react-router-dom";
import { ProtectedRoute } from "../Router";
import lazyRoute from "@/router/lazy-route";

const PatientHome = lazyRoute(
  () => import("@/layout/app/patient-portal/PatientHome")
);
const PatientPortalAppointment = lazyRoute(
  () => import("@/layout/app/patient-portal/PatientPortalAppointment")
);
const PatientPortalLayout = lazyRoute(
  () => import("@/layout/app/patient-portal/PatientPortalLayout")
);
const PatientPortalDashBoard = lazyRoute(
  () => import("@/layout/app/patient-portal/dashboard/PatientPortalDashBoard")
);
const PatientForms = lazyRoute(
  () => import("@/layout/app/patient-portal/forms/PatientForms")
);
const AppointmentCalendar = lazyRoute(
  () =>
    import("@/layout/app/patient-portal/appointment/components/AppointmentCalendar")
);
const PatientPortalAppointmentList = lazyRoute(
  () =>
    import("@/layout/app/patient-portal/appointment/components/PatientPortalAppointmentList")
);
const PatientBilling = lazyRoute(
  () => import("@/layout/app/patient-portal/billing/PatientBillingLayout")
);
const PayementsDue = lazyRoute(
  () => import("@/layout/app/patient-portal/billing/PayementsDue")
);
const PaymentHistory = lazyRoute(
  () => import("@/layout/app/patient-portal/billing/PaymentHistory")
);
const SavedCards = lazyRoute(
  () => import("@/layout/app/patient-portal/billing/SavedCards")
);
const PatientCommunication = lazyRoute(
  () =>
    import("@/layout/app/patient-portal/communication/PatientPortalCommunication")
);
const PatientCompletedDocument = lazyRoute(
  () => import("@/layout/app/patient-portal/documents/PatientCompletedDocument")
);
const PatientDocuments = lazyRoute(
  () => import("@/layout/app/patient-portal/documents/PatientDocuments")
);
const PatientIncompleteDocument = lazyRoute(
  () =>
    import("@/layout/app/patient-portal/documents/PatientIncompleteDocument")
);
const PatientHealthRecord = lazyRoute(
  () => import("@/layout/app/patient-portal/health-record/PatientHealthRecord")
);
const PatientPortalAllergies = lazyRoute(
  () =>
    import("@/layout/app/patient-portal/health-record/PatientPortalAllergies")
);
const PatientPortalCarePlan = lazyRoute(
  () =>
    import("@/layout/app/patient-portal/health-record/PatientPortalCarePlan")
);
const PatientPortalImmunization = lazyRoute(
  () =>
    import("@/layout/app/patient-portal/health-record/PatientPortalImmunization")
);
const PatientPortalMedicalHistory = lazyRoute(
  () =>
    import("@/layout/app/patient-portal/health-record/PatientPortalMedicalHistory")
);
const PatientPortalPastVisit = lazyRoute(
  () =>
    import("@/layout/app/patient-portal/health-record/PatientPortalPastVisit")
);
const PatientPortalTask = lazyRoute(
  () => import("@/layout/app/patient-portal/patient-task/PatientPortalTask")
);
const PatientProviderProfile = lazyRoute(
  () => import("@/layout/app/patient-portal/providers/PatientProviderProfile")
);
const PatientProviders = lazyRoute(
  () => import("@/layout/app/patient-portal/providers/PatientProviders")
);
const PatientPortalNotifications = lazyRoute(
  () =>
    import("@/layout/app/patient-portal/settings/PatientPortalNotifications")
);
const PatientPortalProfile = lazyRoute(
  () => import("@/layout/app/patient-portal/settings/PatientPortalProfile")
);
const ProviderPortalPatientSettings = lazyRoute(
  () =>
    import("@/layout/app/patient-portal/settings/ProviderPortalPatientSettings")
);
const PatientPortalInsurance = lazyRoute(
  () => import("@/layout/app/patient-portal/settings/patientPortalInsurance")
);
const Chat = lazyRoute(
  () => import("@/pages/app/provider/communications/chat/Chat")
);
const PatientPortalEmailTable = lazyRoute(
  () =>
    import("@/layout/app/patient-portal/communication/email/PatientPortalEmailTable")
);
const PatientPortalOrders = lazyRoute(
  () => import("@/layout/app/patient-portal/health-record/PatientPortalOrders")
);
const PatientOrderNewHealthV2 = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/order/orders/PatientOrderNewHealthV2")
);
const OrderReportsHealthV2 = lazyRoute(
  () =>
    import("@/pages/app/provider/patient/patient-list/patient-chart-new/order/result/OrderReportsHealthV2")
);

// import PatientAppointments from "../../layout/app/patient-portal/appointments/PatientAppointments";
// import PatientOrderNewLayout from "../../pages/app/provider/patient/patient-list/patient-chart-new/order/PatientOrderLayout";
// import PatientOrderNew from "../../pages/app/provider/patient/patient-list/patient-chart-new/order/orders/PatientOrderNew";
// import OderResultNew from "../../pages/app/provider/patient/patient-list/patient-chart-new/order/result/OderResultNew";

export const PatientRoute = () => {
  return (
    <Route
      path="patient"
      element={
        <ProtectedRoute accessingViewAs="patient">
          <PatientPortalLayout />
        </ProtectedRoute>
      }
    >
      <Route path="home" element={<PatientHome />} />
      <Route path="dashboard" element={<PatientPortalDashBoard />} />
      {/* <Route path="appointments" element={<PatientAppointments />} /> */}
      <Route path="providers" element={<PatientProviders />} />
      <Route
        path="providers/:providerUuid"
        element={<PatientProviderProfile />}
      />

      <Route path="communication" element={<PatientCommunication />}>
        {/* <Route index element={<SmsText />} /> */}
        <Route path="chat" element={<Chat />} />
        <Route path="email" element={<PatientPortalEmailTable />} />
      </Route>
      <Route path="billing" element={<PatientBilling />} />

      <Route path="documents" element={<PatientDocuments />}>
        <Route index element={<PatientIncompleteDocument />} />
        <Route path="completed" element={<PatientCompletedDocument />} />
      </Route>

      <Route path="billing" element={<PatientBilling />}>
        <Route index element={<PayementsDue />} />
        <Route path="paymentsMade" element={<PaymentHistory />} />
        <Route path="savedCards" element={<SavedCards />} />
      </Route>
      <Route path="documents" element={<PatientDocuments />} />

      <Route path="health-record" element={<PatientHealthRecord />}>
        <Route index element={<PatientPortalMedicalHistory />} />
        <Route path="immunization" element={<PatientPortalImmunization />} />
        <Route path="allergies" element={<PatientPortalAllergies />} />
        <Route path="careplan" element={<PatientPortalCarePlan />} />
        {/* <Route path="order" element={<PatientOrderNewLayout />}>
          <Route index element={<PatientOrderNewHealthV2 />} />
          <Route path="result" element={<OderResultNewHealthV2 />} />
        </Route> */}
        <Route path="order" element={<PatientPortalOrders />}>
          <Route index element={<PatientOrderNewHealthV2 />} />
          <Route path="reports" element={<OrderReportsHealthV2 />} />
        </Route>
        <Route path="past-visit" element={<PatientPortalPastVisit />} />
      </Route>

      <Route path="settings" element={<ProviderPortalPatientSettings />}>
        <Route index element={<PatientPortalProfile />} />
        <Route path="insurance" element={<PatientPortalInsurance />} />
        <Route path="notifications" element={<PatientPortalNotifications />} />
      </Route>
      <Route path="tasks" element={<PatientPortalTask />} />

      <Route path="appointments" element={<PatientPortalAppointment />}>
        <Route index element={<PatientPortalAppointmentList />} />
        <Route path="calendar" element={<AppointmentCalendar />} />
      </Route>
      <Route path="forms" element={<PatientForms />} />
    </Route>
  );
};
